import Login from "UpdatedFeatures/Login/Login";

const LoginPage: React.FC = () => {
  return <Login />;
};

export default LoginPage;
